enum GridColumnTypeEnum {
  MONEY = 'money',
  HOURS = 'hours',
}

export { GridColumnTypeEnum };
